<ng-container *ngIf="!fullscreen">
  <app-header></app-header>
  <div class="flex custom-min-height">
    <div class="container mt-5 mx-auto">
      <div class="flex justify-center items-center" *ngIf="loading">
        <app-spinner></app-spinner>
        <span class="-mt-1 ml-2 mt-20">Loading</span>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</ng-container>

<ng-container *ngIf="fullscreen">
  <router-outlet></router-outlet>
</ng-container>
